import React from "react";
import { Box, Typography, Button, Container, styled } from "@mui/material";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// --- Styled Components (Professional Const Style) ---

const SectionWrapper = styled(Box)(({ theme }) => ({
    width: "100%",
    padding: theme.spacing(12, 0),
    backgroundColor: "transparent", // Clean, no background as requested
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
}));

const ContentContainer = styled(motion.div)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
});

const SectionHeader = styled(Typography)(({ theme }) => ({
    color: "#09122C",
    fontWeight: 800,
    fontSize: "2.8rem",
    letterSpacing: "-0.03em",
    lineHeight: 1.2,
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
        fontSize: "2rem",
    },
}));

const SectionDescription = styled(Typography)(({ theme }) => ({
    color: "#444",
    fontSize: "1.15rem",
    lineHeight: 1.8,
    maxWidth: "800px",
    margin: "0 auto",
    marginBottom: theme.spacing(5),
    fontWeight: 400,
    [theme.breakpoints.down("sm")]: {
        fontSize: "1rem",
    },
}));

const ActionButton = styled(Button)(({ theme }) => ({
    width: "fit-content",
    backgroundColor: "#09122C",
    color: "#FFFFFF",
    fontWeight: 700,
    textTransform: "none",
    padding: "16px 48px",
    borderRadius: "8px", // Slightly more "educational/formal" than the pill shape
    fontSize: "1.05rem",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
        backgroundColor: "#1a2a5a",
        transform: "translateY(-3px)",
        boxShadow: "0 12px 24px rgba(9, 18, 44, 0.2)",
    },
}));

// --- Main Component ---

export default function EnrollmentSection() {
    return (
        <SectionWrapper>
            <Container maxWidth="lg">
                <ContentContainer
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    {/* Professional Badge */}
                    <Typography
                        sx={{
                            color: "#B8860B",
                            fontWeight: 800,
                            fontSize: "0.85rem",
                            letterSpacing: 2,
                            mb: 2,
                            textTransform: "uppercase"
                        }}
                    >
                        Admissions Open
                    </Typography>

                    {/* Main Title */}
                    <SectionHeader variant="h2">
                        UK and Switzerland <br /> Education & Training
                    </SectionHeader>

                    {/* Body Content */}
                    <SectionDescription>
                        Crystal Career Centre provides diverse Education and Training opportunities in London,
                        collaborating with universities across the UK. We support students of all ages with grants,
                        funding, and tuition fee assistance, ensuring they excel in their chosen fields such as
                        health and social care, nursing, business studies, and construction.
                    </SectionDescription>

                    {/* Fit-Size Call to Action */}
                    <Link to="/educational-courses" style={{ textDecoration: "none" }}>
                        <ActionButton variant="contained" disableElevation>
                            Explore Available Courses
                        </ActionButton>
                    </Link>
                </ContentContainer>
            </Container>
        </SectionWrapper>
    );
}
